import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatrolSheetService {

  constructor(private httpClient: HttpClient) { }
   // 根据工单ID查询巡检表单列表
   getPatrolSheetsByJobId(jobId: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/patrolsheet/datas/${jobId}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 根据工单ID查询巡检表单列表
  getPatrolSheetsByJobIdAndgroupId(jobId: any, groupId: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/patrolsheet/datas/${jobId}/${groupId}`).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  async getPatrolSheetsByJobIdAndEpNo(jobId: string, epNo: string) {
    const params = new HttpParams()
      .set('jobId', jobId)
      .set('epNo', epNo);
    const result: any = await this.httpClient.get('plan/api/business/patrolsheet/datas',
      { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  // 更新巡检表单
  updatePatrolSheet(sheet: any) {
    return this.httpClient.put('plan/api/business/patrolsheet/update', sheet).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
}
